import { LicenseMineComponent, LicenseMineUpdateComponent } from './mine/mine.module';
import { RenewComponent } from './renew/renew.component';
import { LicenseComponent } from './license.component';
import { LicenseNewComponent, LicenseNewDetailComponent, LicenseNewHomeComponent, LicenseNewRequestComponent } from './new/new.module';

export {
  LicenseComponent,
  RenewComponent as LicenseRenewComponent,

  LicenseMineComponent,
  LicenseMineUpdateComponent,

  LicenseNewComponent,
  LicenseNewDetailComponent,
  LicenseNewHomeComponent,
  LicenseNewRequestComponent,
};
